
import { Injectable } from "@angular/core";
import { MonthTimetable, TestEvent } from "../models/event.model";

@Injectable({ providedIn: "root" })
export class TimetableService {
  private timetableData: MonthTimetable = {
    

    'Online': [ 
            {
                date: '',
                name: 'Maths',
                description: 'Full Mock: EDEXCEL',
                testtype: "",
                centers: [
                    
                    { 
                      name: 'Paper-2 (Calc)', time: 'From 29/01/2025',
                      examOptions: {
                        
                        EDEXCEL: 'https://www.sehyog.co.uk/11plus-help-club/category/gcse-mock-test/48410d81de98bfb6dede76521b2c1c9a'
                      }
                    },

                    { name: 'Paper-3 (Calc)', time: 'From 29/01/2025',examOptions: {
                      EDEXCEL: 'https://www.sehyog.co.uk/11plus-help-club/category/gcse-mock-test/dbbb73a062dfd0f20da83d2aba8f6bbc'
                    }}

                ]
            },
    
          
            {
              date: '',
              name: 'Physics',
              testtype: "",
              description: 'Full Mock: AQA | OCR | EDEXCEL',
              centers: [
                { name: 'Paper-1', time: 'From: 04/04/2025',examOptions: {
                  AQA: 'https://www.sehyog.co.uk/11plus-help-club/category/gcse-mock-test/8ad29ed62f07a10dc8cbedc5b47c739e',
                  OCR: 'https://www.sehyog.co.uk/11plus-help-club/category/gcse-mock-test/d08b92c70a4124c8fc7bdc4a8339a529',
                  EDEXCEL: 'https://www.sehyog.co.uk/11plus-help-club/category/gcse-mock-test/9b22aad1f0cde21d12c1e3178bf399c4'
                } },

                { name: 'Paper-2', time: 'From: 04/04/2025',examOptions: {
                  AQA: 'https://www.sehyog.co.uk/11plus-help-club/category/gcse-mock-test/e1495e23d455075b40e00cd573dc5cf1',
                  OCR: 'https://www.sehyog.co.uk/11plus-help-club/category/gcse-mock-test/a54faa3a8ac4f2df872cdac3e51d9579',
                  EDEXCEL: 'https://www.sehyog.co.uk/11plus-help-club/category/gcse-mock-test/89a64f94525d2a08c8b2825a09b12792'
                } }
              ]
          },
         
    
              {
                date: '',
                name: 'Chemistry',
                description: 'Full Mock: AQA | OCR | EDEXCEL',
                testtype: "",
                centers: [
                    { name: 'Paper-1', time: 'From: 04/04/2025',examOptions: {
                      AQA: 'https://www.sehyog.co.uk/11plus-help-club/category/gcse-mock-test/8160217cdd6fa360981359cedbd0328d',
                      OCR: 'https://www.sehyog.co.uk/11plus-help-club/category/gcse-mock-test/379f0e634bde3fdee3fd8cfaa5fd1764',
                      EDEXCEL: 'https://www.sehyog.co.uk/11plus-help-club/category/gcse-mock-test/b6bbbf1ca993ec0e37a52785225400db'
                    } },
                    
                    { name: 'Paper-2', time: 'From: 04/04/2025',examOptions: {
                      AQA: 'https://www.sehyog.co.uk/11plus-help-club/category/gcse-mock-test/08ae083b40ee40d976620b13c95f3f5b',
                      OCR: 'https://www.sehyog.co.uk/11plus-help-club/category/gcse-mock-test/382e14b4d096562e802f0d7b258754ac',
                      EDEXCEL: 'https://www.sehyog.co.uk/11plus-help-club/category/gcse-mock-test/3d3e6f07374dff2c071558e2abc4d7f2'
                    } },

                ]
            },
    
          {
            date: '',
            name: 'Biology',
            description: 'Full Mock | Biology | ',
            testtype: "",
            centers: [
                    { name: 'Paper-1', time: 'From: 04/04/2025',examOptions: {
                      AQA: 'https://www.sehyog.co.uk/11plus-help-club/category/gcse-mock-test/3909194e712641520daa856fdb746f84',
                      OCR: 'https://www.sehyog.co.uk/11plus-help-club/category/gcse-mock-test/b6f1dfdc0f77ff4e1fa8a0689d9a6e8c',
                      EDEXCEL: 'https://www.sehyog.co.uk/11plus-help-club/category/gcse-mock-test/6552eeba00ddf0bde00ce9d870dcfc6b'
                    } },

                    { name: 'Paper-2', time: 'From: 04/04/2025',examOptions: {
                      AQA: 'https://www.sehyog.co.uk/11plus-help-club/category/gcse-mock-test/1be73ba6dbbc79a2ee0f63fcf86f656a',
                      OCR: 'https://www.sehyog.co.uk/11plus-help-club/category/gcse-mock-test/5fa1baf673d596176b0c7f82ea86da15',
                      EDEXCEL: 'https://www.sehyog.co.uk/11plus-help-club/category/gcse-mock-test/eb31dcc8ca706034cb4057d0e5524b55'
                    } }
            ]
        },


        {
            date: '',
            name: 'English',
            description: 'Full Mock: AQA | OCR | EDEXCEL',
            testtype: "",
            centers: [
              { name: 'Paper-1 & 3', time: 'From: 04/04/2025',examOptions: {
                AQA: 'https://www.sehyog.co.uk/11plus-help-club/category/gcse-mock-test/84fb25682065403fe9670f9c7de62b8d',
                OCR: 'https://www.sehyog.co.uk/11plus-help-club/category/gcse-mock-test/84da5aeca031e743e918d549ed87467c',
                EDEXCEL: 'https://www.sehyog.co.uk/11plus-help-club/category/gcse-mock-test/edexcel-link'
              } },

              { name: 'Paper-2 & 4', time: 'From: 04/04/2025',examOptions: {
                AQA: 'https://www.sehyog.co.uk/11plus-help-club/category/gcse-mock-test/aqa-link',
                OCR: 'https://www.sehyog.co.uk/11plus-help-club/category/gcse-mock-test/ocr-link',
                EDEXCEL: 'https://www.sehyog.co.uk/11plus-help-club/category/gcse-mock-test/edexcel-link'
              } }
            ]
        },


        {
            date: '',
            name: 'Computer',
            description: 'Full Mock: AQA | OCR | EDEXCEL',
            testtype: "",
            centers: [
              { name: 'Paper-1 & 2', time: 'From: 25/04/2025',examOptions: {
                AQA: 'https://www.sehyog.co.uk/11plus-help-club/category/gcse-mock-test/728454439d495f43353e1fea56a0e8f8',
                OCR: 'https://www.sehyog.co.uk/11plus-help-club/category/gcse-mock-test/0f919157e68ddefed7b5513a9f2a5d2a',
                EDEXCEL: 'https://www.sehyog.co.uk/11plus-help-club/category/gcse-mock-test/edexcel-link'
              } 
            }
            ]
        },
    
    ],

  };

  getMonths(): string[] {
    return ["Online"];
  }

  getTimetable(): MonthTimetable {
    return this.timetableData;
  }
}